import { defineMessages } from 'react-intl-next';

export type Message = {
  id: string;
  defaultMessage: string;
  description: string;
};

export const messages = defineMessages({
  'whiteboards.arrowhead.none': {
    id: 'whiteboards.arrowhead.none',
    defaultMessage: 'None',
    description: 'A none arrowhead, ie a plain path end',
  },
  'whiteboards.arrowhead.arrow': {
    id: 'whiteboards.arrowhead.arrow',
    defaultMessage: 'Arrow',
    description:
      'A default arrow arrowhead, ie end of line has a 2 lines that form an open arrow which looks like ->',
  },
  'whiteboards.arrowhead.filled-arrow': {
    id: 'whiteboards.arrowhead.filled-arrow',
    defaultMessage: 'Filled Arrow',
    description: 'A filled arrow arrowhead, ie a filled triangle at the end of the line',
  },
  'whiteboards.arrowhead.open-arrow': {
    id: 'whiteboards.arrowhead.open-arrow',
    defaultMessage: 'Open Arrow',
    description: 'An open arrow arrowhead, ie an open triangle at the end of the line',
  },
  'whiteboards.arrowhead.filled-diamond': {
    id: 'whiteboards.arrowhead.filled-diamond',
    defaultMessage: 'Filled Diamond',
    description: 'A filled diamond arrowhead, ie a filled diamond at the end of the line',
  },
  'whiteboards.arrowhead.open-diamond': {
    id: 'whiteboards.arrowhead.open-diamond',
    defaultMessage: 'Open Diamond',
    description: 'An open diamond arrowhead, ie an open diamond at the end of the line',
  },
  'whiteboards.arrowhead.open-circle': {
    id: 'whiteboards.arrowhead.open-circle',
    defaultMessage: 'Open Circle',
    description: 'An open circle arrowhead, ie an open circle at the end of the line',
  },
  'whiteboards.arrowhead.slash': {
    id: 'whiteboards.arrowhead.slash',
    defaultMessage: 'Slash',
    description: 'A slash arrowhead, ie a slash at the end of the line',
  },
  'whiteboards.arrowhead.triple-bar': {
    id: 'whiteboards.arrowhead.triple-bar',
    defaultMessage: 'Triple Bar',
    description: 'A triple bar arrowhead, ie a triple bar at the end of the line',
  },
  'whiteboards.arrowhead.open-circle-cross': {
    id: 'whiteboards.arrowhead.open-circle-cross',
    defaultMessage: 'Open Circle Cross',
    description:
      'An open circle cross arrowhead, ie an open circle cross at the end of the line',
  },
  'whiteboards.arrowhead.cross': {
    id: 'whiteboards.arrowhead.cross',
    defaultMessage: 'Cross',
    description: 'A cross arrowhead, ie a cross at the end of the line',
  },
  'whiteboards.arrowhead.crows-foot': {
    id: 'whiteboards.arrowhead.crows-foot',
    defaultMessage: 'Crow Foot',
    description: "A crow's foot arrowhead, ie a crow's foot at the end of the line",
  },
  'whiteboards.arrowhead.circle-crows-foot': {
    id: 'whiteboards.arrowhead.circle-crows-foot',
    defaultMessage: 'Circle Crow Foot',
    description:
      "A circle crow's foot arrowhead, ie a circle crow's foot at the end of the line",
  },
  'whiteboards.arrowhead.cross-with-crows-foot': {
    id: 'whiteboards.arrowhead.cross-with-crows-foot',
    defaultMessage: 'Cross with Crow Foot',
    description:
      "A cross with crow's foot arrowhead, ie a cross with crow's foot at the end of the line",
  },
});
